import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Main from "../components/Main/Main";
import Medicode from "../pages/Medicode";
import BoardList from "../components/Board/BoardList";
import BoardDetail from "../components/Board/BoardDetail";
import Product from "../components/Board/Product/Product";
import ProductDetail from "../components/Board/Product/ProductDetail";
import Sitemap from "../components/Header/Sitemap";

const Router = () => {
  const location = useLocation();

  /* useEffect(() => {
    // 페이지가 변경될 때 스크롤을 최상단으로 이동
    window.scrollTo(0, 0);
  }, [location]); // location이 변경될 때마다 실행 */

  useEffect(() => {
    const isPrerendering = navigator.userAgent.includes("HeadlessChrome");
    if (isPrerendering) return;

    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      {/* ABOUT */}
      <Route path="/medicode" element={<Medicode />} />
      {/* PRODUCT */}
      <Route path="/board/product/:tab" element={<Product />} />{" "}
      {/* 탭별 경로 */}
      <Route
        path="/board/product/detail/:idx"
        element={<ProductDetail />}
      />{" "}
      {/* 상세보기 경로 */}
      {/* HOSPITAL, NEWS, CONTACT US */}
      <Route path="/board/:category" element={<BoardList />} />
      <Route path="/board/:category/:idx" element={<BoardDetail />} />
      <Route path="/sitemap" element={<Sitemap />} />
    </Routes>
  );
};

export default Router;
